<button pButton translate (click)="validate()" [style.opacity]="form?.invalid ? 0.5 : 1" style="width: 100%">
  {{ label }}
</button>
